import React from "react";
import { Link } from "react-router-dom";
import "../style/PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <div className="page-header">
        <h1 className="page-title">Privacy Policy</h1>
      </div>
      <p className="effective-date">Effective Date: July 12, 2025</p>
      
      <div className="privacy-content">
        <p className="intro-text">
          At The Picky Kitty, your privacy matters. This Privacy Policy explains what information we collect, how we use it, and your rights.
        </p>

        <section className="policy-section">
          <h2>1. Information We Collect</h2>
          <p>We collect the following types of information:</p>
          
          <div className="info-type">
            <h3>Usage Data (via Umami Analytics)</h3>
            <p>
              We use a privacy-friendly tool called Umami to collect anonymous usage data such as which pages are visited, 
              how long users stay, and what device or browser is used. This data is not tied to individual users and does 
              not use cookies or track personal identities.
            </p>
          </div>


        </section>

        <section className="policy-section">
          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Understand how people use our website</li>
            <li>Improve our content, tools, and features</li>
            <li>Monitor the performance of affiliate links</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>3. Cookies</h2>
          <p>
            We do not use third-party tracking cookies. Umami Analytics does not use cookies. 
            Any cookies used are strictly necessary for basic site functionality (e.g., remembering form inputs).
          </p>
        </section>

        <section className="policy-section">
          <h2>4. Affiliate Links</h2>
          <p>
            We participate in the Amazon Associates program. This means we may earn a commission if you click on an 
            Amazon link and make a purchase - at no extra cost to you. These links may allow Amazon to track your activity. 
            Please refer to Amazon's Privacy Notice for details. You can also read our <Link to="/amazon-disclosure" className="contact-link">Amazon Associate Program Disclosure</Link> for more information.
          </p>
        </section>

        <section className="policy-section">
          <h2>5. Data Sharing</h2>
          <p>
            We do not sell, rent, or share your personal data with any third parties. 
            Usage data is anonymized and only used internally to improve the site.
          </p>
        </section>



        <section className="policy-section">
          <h2>6. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Any changes will be posted here with an updated effective date.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 